import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, isEmpty, services, sizes } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import textareaField from '@/components/services/settings/textarea/field'
import tag from '@/components/tag'

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${services.settingsUser}.warnings.smpp.ipAddresses`),
        color: Colors.error
      }
    }
  )
}
function renderInvalid(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--4'
    },
    [
      this.invalid.map(label => {
        return h(
          tag,
          {
            props: {
              label,
              color: Colors.error,
              size: sizes.tiny
            }
          }
        )
      })
    ]
  )
}
function renderDialogInfo(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderInfo.call(this, h),
      renderInvalid.call(this, h)
    ]
  )
}
function renderDialogBody(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--18 px-2'
    },
    [
      renderDialogInfo.call(this, h),
      renderTextarea.call(this, h, false)
    ]
  )
}
function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.cancel'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.save'),
            color: Colors.primary,
            loading: this.loading.update,
            disabled: this.disabled
          },
          on: {
            click: () => {
              this.check()
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  let dialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    dialogMaxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate('commons.titles.confirm.title'),
        value: this.showDialog && this.invalid.length,
        maxWidth: dialogMaxWidth
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}

function renderTextarea(h, details = true) {
  return h(
    textareaField,
    {
      props: {
        value: this.proxy,
        details
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
function renderConfirmButton(h) {
  return h(
    button,
    {
      props: {
        icon: icons.done,
        color: Colors.success,
        mode: buttonModes.flat,
        tooltip: this.getTranslate('misc.buttons.save'),
        loading: this.loading.update,
        disabled: this.disabled
      },
      on: {
        click: () => {
          this.check()
        }
      }
    }
  )
}
function renderClearButton(h) {
  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: icons.clear,
        color: Colors.error,
        tooltip: this.getTranslate('misc.buttons.clear'),
        disabled: isEmpty(this.proxy)
      },
      on: {
        click: () => {
          this.reset()
        }
      }
    }
  )
}
function renderButtons(h) {
  if (this.complex) {
    return h(
      'div',
      {
        class: 'fc grid-gap--8'
      },
      [
        renderConfirmButton.call(this, h),
        renderClearButton.call(this, h),
        renderDialog.call(this, h)
      ]
    )
  }
}

function renderContent(h) {
  let contentGridColumns
  if (this.complex) {
    contentGridColumns = '1fr auto'
  } else {
    contentGridColumns = '1fr '
  }

  return h(
    'div',
    {
      class: 'grid grid-gap--8',
      style: { gridTemplateColumns: contentGridColumns }
    },
    [
      renderTextarea.call(this, h),
      renderButtons.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.card,
    {
      class: 'px-2 pb-2 pt-3',
      props: {
        title: this.getTranslate(`${services.settingsUser}.labels.smpp.ipWhitelist`),
        outline: true,
        dashed: true,
        rounded: true
      }
    },
    [ renderContent.call(this, h) ]
  )
}
